import styled from 'styled-components';

import { fontWeight } from 'stylesheetB2b';
import { fontSize } from 'stylesheetB2c';

const LAST_SONG_MESSAGE_Z_INDEX = 3;

export const StyledTVMessage = styled.div`
  position: absolute;
  z-index: ${LAST_SONG_MESSAGE_Z_INDEX};
  top: 0;
  height: 15%;
  width: 100%;
  font-size: ${fontSize.giant};
  font-weight: ${fontWeight.bold};
  display: flex;
  opacity: 0.7;
  justify-content: center;
  align-items: center;
  background: black;
  line-height: 50px;
  text-align: center;
  white-space: pre-line;
`;
